import { createStore } from 'vuex';
import { getApplicant } from '@/api/applicant';

export default createStore({
  state: {
    isLoading: false,
    showInfiniteLoading: false,
    applicant: null,
  },
  mutations: {
    setLoadingState(state, data) {
      state.isLoading = data.status;
    },
    setInfiniteLoading(state, data) {
      state.showInfiniteLoading = data.status;
    },
    setApplicantInfo(state, data) {
      // eslint-disable-next-line
      data.birthday = new Date(data.birthday);
      state.applicant = data;
    },
  },
  actions: {
    loadApplicantInfo(context, id) {
      getApplicant(id).then((response) => {
        context.commit('setApplicantInfo', response);
      });
    },
  },
  modules: {
  },
  getters: {
    getLoadingState(state) {
      return state.isLoading;
    },
    getInfiniteLoading(state) {
      return state.showInfiniteLoading;
    },
    getApplicantInfo(state) {
      return state.applicant;
    },
  },
});
